import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const AppPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#f8f4ed',
      100: '#eddcc5',
      200: '#e1c39a',
      300: '#d5a96f',
      400: '#c99144',
      500: '#c39a5b', // --text-gold
      600: '#a6824d',
      700: '#896b3f',
      800: '#6c5431',
      900: '#4f3d23',
      950: '#322615'
    },
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '#f9fafb',
          100: '#f3f4f6',
          200: '#e5e7eb',
          300: '#d1d5db',
          400: '#9ca3af',
          500: '#6b7280',
          600: '#4b5563',
          700: '#374151',
          800: '#1f2937',
          900: '#111827',
          950: '#030712'
        }
      }
    }
  },
  components: {
    megamenu: {
      colorScheme: {
        light: {
          root: {
            background: '#beb8b2', // --background
            borderColor: 'transparent',
            gap: '0',
            horizontalOrientation: {
              gap: '2rem',
              padding: '1rem 0.75rem'
            }
          },

          item: {
            padding: '0.5rem 0.75rem',
            color: '#4a4945', // --text-dark
            focusBackground: '#beb8b2',
            focusColor: '#ffffff',
            activeBackground: '#beb8b2',
            activeColor: '#ffffff',
            icon: {
              color: '#4a4945',
              focusColor: '#ffffff',
              activeColor: '#ffffff'
            }
          },
          submenuIcon: {
            color: '#4a4945',
            focusColor: '#ffffff',
            activeColor: '#ffffff'
          },
          overlay: {
            background: '#a39d96', // --accent-gray
            borderColor: 'transparent',
            padding: '0',
            gap: '0'
          },
          submenu: {
            padding: '0',
            gap: '0'
          }
        }
      }
    }
  }
});
